import { combineReducers } from 'redux';

import userReducer from './userReducer';
import peopleStructureReducer from './peopleStructureReducer';
// import accountReducer from './accountReducer';

const Reducers = combineReducers({
  userState: userReducer,
  peopleStructureState: peopleStructureReducer
  // accountState: accountReducer
});

export default Reducers;
